import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, Form, Button, FormFeedback } from 'reactstrap';
import { addNewUserFormValidator } from 'form-validations';
import { connect } from 'react-redux';
import { UserAction } from 'redux/actions';

const AddUser = (props) => {

    const [values, setvalues] = React.useState({});
    let [errors, setErrors] = React.useState({});
    let [isValid, setIsValid] = React.useState(true);
    let [isSubmitted, setIsSubmitted] = React.useState(false);

    const handleChange = (event) => {
        setvalues({ ...values, [event.target.name]: event.target.value })
    }

    React.useEffect(() => {
        const validationErrors = addNewUserFormValidator(values);
        isValid = Object.keys(validationErrors).length === 0;
        setIsValid(isValid);
        setErrors(validationErrors);
    }, [values]);


    const handleSubmit = () => {
        setIsSubmitted(true);
        if(isValid){
            const payload = {...values}
            payload['is_admin'] = props.isAdmin
            props.addUser(payload)
        }
    }

    return (
        <div>
            <Form>
                <FormGroup>
                    <Label for={'name'}>{'Name'}</Label>
                    <Input
                        type="text"
                        name="name"
                        id="name"
                        onChange={handleChange}
                        autoComplete={'off'}
                        value={(values && values.name)?values.name:''}
                    />
                    {(isSubmitted && errors.name && !values.name) && <FormFeedback >{errors.name} </FormFeedback>}
                </FormGroup>
                <FormGroup>
                    <Label for={'username'}>{'Username'}</Label>
                    <Input
                        type="text"
                        name="username"
                        id="username"
                        onChange={handleChange}
                        autoComplete={'off'}
                        value={(values && values.username)?values.username:''}
                    />
                    {(isSubmitted && errors.username && !values.username) && <FormFeedback >{errors.username} </FormFeedback>}
                </FormGroup>
                <FormGroup>
                    <Label for={'email'}>{'Email'}</Label>
                    <Input
                        type="text"
                        name="email"
                        id="email"
                        onChange={handleChange}
                        autoComplete={'off'}
                        value={(values && values.email)?values.email:''}
                    />
                    {(isSubmitted && errors.email && !values.email) && <FormFeedback >{errors.email} </FormFeedback>}
                </FormGroup>

                <FormGroup>
                    <Label for={'phone'}>{'Phone'}</Label>
                    <Input
                        type="text"
                        name="phone"
                        id="phone"
                        onChange={handleChange}
                        autoComplete={'off'}
                        value={(values && values.phone)?values.phone:''}
                    />
                    {(isSubmitted && errors.phone && !values.phone) && <FormFeedback >{errors.phone} </FormFeedback>}
                </FormGroup>

                <FormGroup>
                    <Label for={'password'}>{'Password'}</Label>
                    <Input
                        type="password"
                        name="password"
                        id="password"
                        onChange={handleChange}
                        autoComplete={'off'}
                        value={(values && values.password)?values.password:''}
                    />
                    {(isSubmitted && errors.password && !values.password) && <FormFeedback >{errors.password} </FormFeedback>}
                </FormGroup>

                <Button
                    size="lg"
                    color="primary"
                    className="border-0"
                    block
                    onClick={handleSubmit}>
                    Create
                </Button>
            </Form>
        </div>
    );
}

AddUser.propTypes = {
    isAdmin: PropTypes.bool,
    addUser:PropTypes.func,
};


const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
    addUser: (payload) => dispatch(UserAction.addUser(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
